import {Component} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {KeycloakService} from "./services/keycloak.service";

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: 'app.component.html',
})

export class AppComponent {

  isAdmin: boolean = false;

  constructor(private http: HttpClient, private kc: KeycloakService){
    this.kc.getToken()
      .then(token => {
        let headers = new HttpHeaders({
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + token
        });

        let options =  {headers: headers};

      })
  }

  logout() {
    this.kc.logout();
  }
}
